// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"299":"202396d0","424":"37387f13","488":"a5ced5a2","748":"df127e19","794":"39cd7663","801":"7b1e107d"}[chunkId] + ".chunk.js";
};